import { QueryClient } from "@tanstack/react-query"

// Create a client with default configuration
export const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         // Time before cached data is considered stale (5 minutes)
         staleTime: 1000 * 60 * 5,
         // Time before inactive queries are garbage collected (10 minutes)
         cacheTime: 1000 * 60 * 10,
         // Retry failed requests 1 time
         retry: 2,
         // Don't refetch on window focus by default
         refetchOnWindowFocus: true,
         // Refetch on mount if data is stale
         refetchOnMount: true,
         // Refetch on reconnect if data is stale
         refetchOnReconnect: true,
      },
      mutations: {
         // Retry failed mutations 0 times
         retry: 0,
      },
   },
})
